import BN from "bn.js";
import { noop } from "lodash";
import { createContext, FC } from "react";
import { None } from "space-monad";
import { EmptyFetchable } from "../../../store/common/fetchable/helpers";
import { useStaking } from "./staking-hook";

export const StakeContext = createContext<ReturnType<typeof useStaking>>({
  decimals: None,
  isChainSupported: false,
  stats: EmptyFetchable,
  currentContract: None,
  stake: (x: BN) => Promise.reject(),
  unstake: () => Promise.reject(),
  claimRewards: (stake: boolean) => Promise.reject(),
  stakingContractId: None,
  allContracts: None,
  setStakingContractId: noop,
});

export const StakeContextProvider: FC<{}> = ({ children }) => {
  const staking = useStaking();

  return (
    <StakeContext.Provider value={staking}>{children}</StakeContext.Provider>
  );
};
